import React, { useEffect, useState } from "react";
import { Button, Select, Spin } from "antd";
// import {
//   fetchBill,
//   getBbpsformParams,
//   payBill,
// } from "../../../../ApiServices/Apifun";

import {
  getBillersByType,
  payCreditCardBill,
} from "../../../ApiServices/Apifun";
import { BBPS } from "../../../Assets/BBPS";
import ReportDrawer from "../../../Common/ReportDrawer";
import Content from "../../../Common/ReceiptContent";
import { getLocalStorageItem } from "../../../Utils";

const CreditCardBillPay = (props) => {
  const { billerType, service_name, circles } = props;
  const [billers, setBillers] = useState([]);
  const [selectedBiller, setselectedBiller] = useState({});
  const [selectLoading, setSelectLoading] = useState(false);
  const [Btnloading, setBtnLoading] = useState(false);
  const [getFieldsLoader, setGetFieldsLoader] = useState(false);
  const [AllOerators, setAllOperators] = useState([]);
  const [billDetail, setBillDetail] = useState({});
  const [selectedOperator, setselectedOperator] = useState(null);
  const [selectedCircle, setselectedCircle] = useState(null);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [PaybillResult, setPaybillResult] = useState({
    data: null,
    transaction_id: null,
  });
  const [renderField, setRenderField] = useState([]);
  const [disableAmount, setDisableAmount] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [isfetch, setIsFetch] = useState(0);
  const [disableOperatorField, setDisableOperatorField] = useState(false);
  const [BtnState, setBtnState] = useState("");
  const [fields, setFields] = useState({});
  const [amount, setamount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [billDate, setBillDate] = useState("");
  const [billDueDate, setBillDueDate] = useState("");
  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    setselectedOperator(null);
    setBillers([]);
    setRenderField([]);
    setOpenReceiptDrawer(false);
    setPaybillResult({ data: null, transaction_id: null });
    setamount("");
    setBillDetail({});
    setDisableOperatorField(false);
    setBtnLoading(false);
    setDisableAmount(false);
    setSelectLoading(false);
    setShowDetail(false);
    setFields({});
    setGetFieldsLoader(false);
    setAllOperators({});
  }, [billerType]);

  const billersByBillerType = () => {
    setSelectLoading(true);
    setDisableOperatorField(true);
    let payload = {
      billerType: billerType,
    };
    getBillersByType(payload)
      .then((res) => {
        if (res.status) {
          setAllOperators(res.data);
          setBillers(
            res.data.map((item, index) => {
              return {
                label: item.name,
                value: item.billerId,
                billerData: item,
              };
            })
          );
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setSelectLoading(false);
        setDisableOperatorField(false);
      });
  };
  useEffect(() => {
    billersByBillerType();
  }, [billerType]);
  //   useEffect(() => {
  //     if (selectedOperator) {
  //       setShowDetail(false);
  //       setGetFieldsLoader(true);
  //       getBbpsformParams(`${type + "/" + selectedOperator}`)
  //         .then((res) => {
  //           if (res.status) {
  //             setRenderField(res.data);
  //             const objectFromDataArray = res.data.reduce((obj, item) => {
  //               obj[item.fieldKey] = "";
  //               return obj;
  //             }, {});
  //             setFields(objectFromDataArray);
  //           }
  //         })
  //         .catch((err) => console.log(err))
  //         .finally(() => setGetFieldsLoader(false));
  //       const checktype = AllOerators.filter(
  //         (item, index) => item?.biller_id === selectedOperator
  //       )[0]?.is_fetch;
  //       setIsFetch(checktype);
  //       checktype === 1 ? setBtnState("Fetch Bill") : setBtnState("Pay Bill");
  //       // setIsfetch(
  //       //   AllOerators.filter(
  //       //     (item, index) => item?.biller_id === selectedOperator
  //       //   )[0]?.is_fetch
  //       // );
  //     }
  //   }, [selectedOperator]);

  const handleChange = (e, type, key, regex) => {
    const value = e.target.value;

    setFields((prev) => ({ ...prev, [key]: value }));

    if (regex && value !== "") {
      const isValid = regex.test(value);
      setErrors((prev) => ({ ...prev, [key]: !isValid }));
    } else {
      // no regex, clear error
      setErrors((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handeBtnSubmit = () => {
    setBtnLoading(true);
    setDisableOperatorField(true);

    const formdata = new FormData();
    formdata.append("billerId", selectedBiller.billerId);
    formdata.append("billerType", billerType);
    formdata.append("circle", selectedCircle);
    // formdata.append("billDate", billDate);
    // formdata.append("billDueDate", billDueDate);
    formdata.append("name", name);
    formdata.append("email", email);
    formdata.append("amount", amount);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    Object.entries(fields).forEach(([key, value]) => {
      formdata.append(`billParams[${key}]`, value);
    });

    console.log([...formdata.entries()]);
    payCreditCardBill(formdata)
      .then((res) => {
        if (res.status) {
          setPaybillResult({
            data: {
              Amount: amount,
              Circle: selectedCircle,
              "Biller Name": name,
              Email: email,
              Service: "Credit Card",
              "Transaction Date": res.data.created_at,
              Status:
                res.data.status === "0"
                  ? "Pending"
                  : res.data.status === "1"
                  ? "Success"
                  : "Failed",
              Remark: res.data.remark,
            },
            transaction_id: res.data.transaction_id,
          });

          setOpenReceiptDrawer(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setBtnLoading(false);
        setDisableOperatorField(false);
      });
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 w place-items-start gap-3">
        <Spin spinning={getFieldsLoader}>
          <div className="prepaid bg-white w-full shadow-normal rounded-3xl   p-5">
            <div className="flex justify-between items-center">
              <p className="font-bold capitalize text-[15px] mb-2">
                {service_name} Payment
              </p>
              {/* <BBPS /> */}
            </div>
            <Spin spinning={selectLoading}>
              <div className="selectionFields ">
                <div>
                  <p className="required text-textGray mb-2">Select Operator</p>
                  <Select
                    showSearch
                    placeholder="Select an operator"
                    value={selectedOperator}
                    loading={selectLoading}
                    disabled={disableOperatorField}
                    className="w-full mb-2"
                    filterOption={(input, option) => {
                      const label =
                        typeof option?.label === "string"
                          ? option.label
                          : typeof option?.children === "string"
                          ? option.children
                          : "";
                      return label.toLowerCase().includes(input.toLowerCase());
                    }}
                    options={
                      billers?.map((biller) => ({
                        label:
                          biller.name || biller.operatorName || biller.label,
                        value: biller.id || biller.value,
                        billerData: biller,
                      })) || []
                    }
                    onChange={(value, option) => {
                      const selectedBiller = option?.billerData;
                      if (!selectedBiller) return;
                      setRenderField(
                        selectedBiller?.billerData?.inputParams || []
                      );
                      setselectedBiller(selectedBiller?.billerData);
                      setselectedOperator(value);
                      setShowDetail(true);
                    }}
                  />
                </div>
                <div>
                  <p className={`required text-textGray mb-2`}>Select Circle</p>
                  <Select
                    showSearch
                    placeholder="Select a Circle"
                    value={selectedCircle}
                    loading={selectLoading}
                    onChange={(value) => {
                      setselectedCircle(value);
                      setShowDetail(true);
                    }}
                    className="w-full mb-2"
                    filterOption={(input, option) => {
                      const label =
                        typeof option?.label === "string"
                          ? option.label
                          : typeof option?.children === "string"
                          ? option.children
                          : "";
                      return label.toLowerCase().includes(input.toLowerCase());
                    }}
                    options={
                      Array.isArray(circles)
                        ? circles.map((c) => ({
                            label: String(c),
                            value: String(c),
                          }))
                        : []
                    }
                  />
                </div>
                {renderField.length !== 0
                  ? renderField.map((item, index) => {
                      const value = fields[item.paramKey] || "";
                      const isError = errors[item.paramKey];
                      const regex = item.paramRegex
                        ? new RegExp(item.paramRegex)
                        : null;

                      return (
                        <div key={index} className="mb-3">
                          <p className="capitalize text-textGray mt-2 text-xs mb-2">
                            {item.paramName}
                            {item.mandatory && (
                              <span className="text-red-500 ml-1">*</span>
                            )}
                          </p>

                          <input
                            name={item.paramKey}
                            value={value}
                            placeholder={`Enter ${item.paramName}`}
                            required={item.mandatory}
                            disabled={disableOperatorField}
                            type={
                              item.paramType === "NUMERIC" ? "number" : "text"
                            }
                            onChange={(e) =>
                              handleChange(
                                e,
                                item.paramType,
                                item.paramKey,
                                regex
                              )
                            }
                            className={`outline-none text-xs border w-full h-9 px-2 rounded-md ${
                              isError
                                ? "border-red-500"
                                : "border-gray-200 focus:border-primary"
                            }`}
                          />

                          {isError && (
                            <p className="text-red-500 text-[11px] mt-1">
                              {item.invalidParamError}
                            </p>
                          )}
                        </div>
                      );
                    })
                  : null}

                {selectedOperator && (
                  <div
                    className={`${
                      isfetch === 1 &&
                      type !== "fasttag" &&
                      BtnState === "Fetch Bill"
                        ? "hidden"
                        : "block"
                    }`}
                  >
                    <p className={`required capitalize text-textGray mb-2`}>
                      Amount
                    </p>
                    <input
                      value={amount}
                      min={1}
                      disabled={disableAmount && type !== "fasttag"}
                      onChange={(e) => setamount(e.target.value)}
                      type="number"
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    />
                    <p className={`required capitalize text-textGray mb-2`}>
                      Name
                    </p>
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    />
                    <p className={`required capitalize text-textGray mb-2`}>
                      Email
                    </p>
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    />
                    {/* <p className={`required capitalize text-textGray mb-2`}>
                      Bill Date
                    </p>
                    <input
                      value={billDate}
                      onChange={(e) => setBillDate(e.target.value)}
                      type="date"
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    />
                    <p className={`required capitalize text-textGray mb-2`}>
                      Bill Due Date
                    </p>
                    <input
                      value={billDueDate}
                      onChange={(e) => setBillDueDate(e.target.value)}
                      type="date"
                      className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                    /> */}
                  </div>
                )}
              </div>
            </Spin>
            {selectedOperator && (
              <div className="mt-2">
                <Button
                  disabled={Object.values(fields).some((value) => value === "")}
                  loading={Btnloading}
                  onClick={handeBtnSubmit}
                  className="bg-primary w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                >
                  {/* {isFetch === 1 ? "Fetch Bill" : "Pay Bill"} */}
                  {/* {BtnState} */}
                  Pay Bill
                </Button>
              </div>
            )}
          </div>
        </Spin>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={"Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={PaybillResult} />}
        />
      )}
    </>
  );
};

export default CreditCardBillPay;
